/* Copyright (c) 2026 Xperi. All Rights Reserved. */

export { default as networkAvailabilityReducer } from "./networkAvailabilitySlice";
export {
  resourceAvailabilityChanged,
  selectNetworkAvailability,
  selectNetworkInterfaceStatus,
  selectInternetStatus,
  selectResourceStatus
} from "./networkAvailabilitySlice";
export type {
  NetworkAvailabilityState,
  ResourceStatus
} from "./networkAvailability.types";
export { NetworkAvailabilityBridge } from "./NetworkAvailabilityBridge";
